import React from "react";
import { FaWhatsapp, FaLink, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { useClickOutside } from "../../customHooks/clickOutside";
import { useRef } from "react";

const ShareModal = ({ onClose, shareUrl }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  const ref = useRef(null);

  useClickOutside(ref, () => {
    onClose();
  });
  const handleWhatsappClick = () => {
    window.open(
      `https://wa.me/?text=Mother's%20Pride%20Blog%3A%0A ${shareUrl}`,
      "_blank",
      "noopener",
      "noreferrer"
    );
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div
        ref={ref}
        className="bg-white p-6 rounded-xl w-full max-w-sm relative shadow-lg"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-black"
        >
          <FaTimes size={18} />
        </button>
        <h2 className="text-lg font-semibold mb-4">Share this link</h2>

        <div className="flex justify-around items-center space-x-4">
          <button
            onClick={handleCopy}
            className="flex flex-col cursor-pointer items-center text-gray-700 hover:text-black"
          >
            <FaLink size={24} />
            <span className="text-sm mt-1">Copy URL</span>
          </button>

          <p
            onClick={handleWhatsappClick}
            className="flex flex-col cursor-pointer items-center text-green-600 hover:text-green-700"
          >
            <FaWhatsapp size={24} />
            <span className="text-sm mt-1">WhatsApp</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
